module.exports = __webpack_public_path__ + "img/building.37f0a98c.svg";